import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { MoveRight, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function PutAway() {
  const { can } = useAuth();
  const [refresh, setRefresh] = useState(0);

  const complete = async (row, reload) => {
    const loc = window.prompt("Enter destination bin/location code:", "WH-A1-R1");
    if (!loc) return;
    try { await api.post(`/putaway/${row.id}/complete`, { location_id: loc }); toast.success("Put-away completed"); reload(); }
    catch { toast.error("Failed"); }
  };

  const cols = [
    { key: "task_no", label: "Task No", mono: true },
    { key: "grn_no", label: "GRN Ref", mono: true },
    { key: "sku", label: "SKU", mono: true },
    { key: "item_name", label: "Item", render: (r) => <span className="font-medium">{r.item_name}</span> },
    { key: "quantity", label: "Qty" },
    { key: "location_id", label: "Location", render: (r) => r.location_id || "—" },
    { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  ];

  return (
    <div>
      <PageHeader title="Put Away" subtitle="Suggested bins & capacity-validated placement" icon={MoveRight}
        breadcrumb={["Home", "Operations", "Put Away"]} />
      <DataTable endpoint="/putaway" columns={cols} testId="putaway-table" refreshKey={refresh}
        actions={(row, reload) => row.status === "pending" && can("putaway.update") && (
          <Button size="sm" variant="outline" data-testid={`complete-putaway-${row.id}`} onClick={() => complete(row, reload)}
            className="text-emerald-600 border-emerald-200 hover:bg-emerald-50">
            <CheckCircle2 className="h-4 w-4 mr-1" />Complete
          </Button>
        )} />
    </div>
  );
}
